import { useBusinessCommunities } from '../store'

const useCommunities = (businessId: string) => {
  return useBusinessCommunities(businessId)
}

export { useCommunities }
